import EshopConfiguration from "../services/EshopConfiguration";
import adultWarningFormService from "../general/AdultWarningFormService";
import productCardClickService from "../services/ProductCardClickService";
import insertProductToBasketService from "../basket/insert/InsertProductToBasketService";
import priceRequestFormService from "./PriceRequestFormService";
import errorReportFormService from "./ErrorReportFormService";
import productQuestionFormService from "./ProductQuestionFormService";
import ProductDetailPageTypeConfig from "./ProductDetailPageTypeConfig";
import subscribePackageWatchdogFormService from "./SubscribePackageWatchdogFormService";
import productModalGalleryService from "./gallery/ProductModalGalleryService";
import productListGalleryService from "./gallery/ProductListGalleryService";
import heurekaReviewScrollService from "./HeurekaReviewScrollService";
import showMoreDescriptionTextService from "./ShowMoreDescriptionTextService";
import productDetailQuestionTogglerService from "./ProductDetailQuestionTogglerService";
import detailTabSwitchService from "./DetailTabSwitchService";
import productCustomerLiveNotificationService from "./ProductCustomerLiveNotificationService";
import priceWatchdogFormService from "./PriceWatchdogFormService";
import productActionPriceInfoService from "./ProductActionPriceInfoService";
import productPriceComparisonModalService from "./ProductPriceComparisonModalService";
import productDeliveryPriceModalService from "./ProductDeliveryPriceModalService";
import productDescriptionDetailModalService from "./ProductDescriptionDetailModalService";

export default class ProductDetailPageService {
    public init(
        eshopConfiguration: EshopConfiguration,
        pageTypeConfig: ProductDetailPageTypeConfig,
    ): void {
        productCustomerLiveNotificationService.init();
        insertProductToBasketService.init();
        productDescriptionDetailModalService.init(pageTypeConfig);
        priceWatchdogFormService.init(pageTypeConfig, eshopConfiguration.currencyId);
        priceRequestFormService.init(pageTypeConfig);
        errorReportFormService.init(pageTypeConfig);
        productActionPriceInfoService.init(pageTypeConfig, eshopConfiguration.currencyId);
        productModalGalleryService.init(pageTypeConfig, eshopConfiguration.currencyId);
        productPriceComparisonModalService.init(pageTypeConfig, eshopConfiguration.currencyId);
        productDeliveryPriceModalService.init();
        detailTabSwitchService.init();
        this.intProducCardClicks();

        if (pageTypeConfig.detailType === "sold") {
            subscribePackageWatchdogFormService.init(pageTypeConfig);
        }

        if (pageTypeConfig.detailType !== "sold") {
            productListGalleryService.init();
            heurekaReviewScrollService.init();
            showMoreDescriptionTextService.init();
        }

        productDetailQuestionTogglerService.init();
        productQuestionFormService.init();

        if (pageTypeConfig.isAdult) {
            adultWarningFormService.init();
        }
    }

    private intProducCardClicks(): void {
        for (const recommendedProductListContainer of document.querySelectorAll<HTMLDivElement>(".js-recommended-product-list")) {
            productCardClickService.initForContainer(recommendedProductListContainer);
        }
    }
}
